export const projectType= [
        { value: '1', label: '定制软件' },
        { value: '2', label: '教育培训' },
        { value: '3', label: '旅行社' },
        { value: '4', label: '全行业' },
    ]

export function getProjectTypeLabel(value) {
    const item = projectType.find(i => i.value === value);
    return item ? item.label : '';
}